import React, { useState, useEffect } from 'react';

// Layouts
import HeaderMulti from './Layouts/header-multi';
import Footer from './Layouts/footer';

// Components
import HeroSection from '../components/Hero/HeroSection';
import ScrollIndicator from '../components/UI/ScrollIndicator';
import FeatureHighlight from '../components/Features/FeatureHighlight';
import FeatureCard from '../components/Features/FeatureCard';

// SubPages - keeping content for legal requirements
import AboutUs from './SubPages/Multipurpose/about-us';
import Features from './SubPages/Multipurpose/features';
import Services from './SubPages/Multipurpose/applications';
import Cta from './SubPages/Multipurpose/cta';
import Contact from './SubPages/Multipurpose/contact';

// Data
import { enterpriseFeatures } from '../data/features';

// Images
import imgKhyrosTopPattern from '../images/product/khyros-work-pattern-framed.png';

const HomeBusiness: React.FC = () => {
  const [isScreenshotOpen, setIsScreenshotOpen] = useState(false);

  const scrollNavigation = () => {
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    const navBar = document.getElementById('nav-bar');
    if (top > 80) {
      navBar?.classList.add('nav-sticky');
    } else {
      navBar?.classList.remove('nav-sticky');
    }
  }

  useEffect(() => {
    document.body.className = "modern-dark-theme";
    window.addEventListener("scroll", scrollNavigation, true);
    
    return () => {
      window.removeEventListener("scroll", scrollNavigation, true);
      document.body.className = "";
    };
  }, []);

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    aboutSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <React.Fragment>
      {/* Header */}
      <HeaderMulti />

      {/* Screenshot Modal */}
      {isScreenshotOpen && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%' }}>
            <button 
              onClick={() => setIsScreenshotOpen(false)}
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '30px',
                cursor: 'pointer'
              }}
            >
              ×
            </button>
            <img src={imgKhyrosTopPattern} alt="Khyros Pattern" style={{ maxWidth: '100%', maxHeight: '100%' }} />
          </div>
        </div>
      )}

      {/* Hero Section */}
      <HeroSection
        title="Geospatial Intelligence<br />Powered by AI"
        subtitle="Khyros transforms complex geospatial data into actionable intelligence, identifying patterns, anomalies, and future events with verifiable accuracy"
        ctaText="Start Free Trial"
        ctaLink="/#contact"
      >
        <ScrollIndicator onClick={scrollToAbout} />
      </HeroSection>

      {/* Feature Highlights */}
      <FeatureHighlight
        title="Enterprise-Grade Intelligence"
        subtitle="Built for government and defense organizations that demand precision, security, and scalability"
      >
        {enterpriseFeatures.map((feature, index) => (
          <FeatureCard
            key={index}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </FeatureHighlight>

      {/* Original SubPages - Keeping content for legal requirements */}
      <AboutUs />
      <Features />
      <Services />
      <Cta />
      <Contact />

      <Footer />
    </React.Fragment>
  );
}

export default HomeBusiness;
